const ua = navigator.userAgent.toLowerCase()

export const isIE = ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0
export const isEdge = ua.includes('edge')
export const isFirefox = ua.includes('firefox')
